var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$offline)?_c('page-500',{attrs:{"back":_vm.backFromOffline,"message":_vm.$t('shared.youAreOffline')}}):_c('div',[_c('progress-bar'),_c('notifications'),(_vm.isPublic)?_c('pub'):(_vm.isPrint)?_c('prnt'):_c('cp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }